import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sports';

export default function CategoryGrid() {
  return (
    <section className="relative -mt-12 z-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 rounded-lg p-4 md:p-5 text-center hover:shadow-md transition-all duration-200 cursor-pointer group border border-background-200/70"
            >
              <div className={`w-12 h-12 mx-auto mb-3 rounded-full flex items-center justify-center ${cat.color === 'primary' ? 'bg-primary-50 text-primary-500' : 'bg-accent-50 text-accent-500'} group-hover:scale-110 transition-transform duration-200`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">{cat.name}</h3>
              <p className="text-xs text-foreground-500 mt-1">{cat.nameEn}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}